module.exports = __webpack_public_path__ + "static/media/web.fb39b7d1.jpg";